import { useEffect, useState } from 'react';
import { subscribeSaldosCustodioMeta } from '../services/saldosService';

/**
 * Estado de la carga automática de saldos del custodio de `fecha` (API de Rosval,
 * 09:30). Solo staff: en modo productor (`enabled` false) no se suscribe.
 */
export const useSaldosCustodioMeta = (fecha, enabled) => {
  const [meta, setMeta] = useState(null);

  useEffect(() => {
    if (!enabled || !fecha) {
      setMeta(null);
      return undefined;
    }
    return subscribeSaldosCustodioMeta(fecha, setMeta, () => setMeta(null));
  }, [fecha, enabled]);

  return meta;
};
